import type {
  MessageResultDTO,
  MessageResultV2DTO,
} from '@nora-monorepo/nora-api-client';

import { useChatUserStore } from '#nora-chat-ui/stores/user-store';
import { aggregateReactions } from '#nora-chat-ui/utils/aggregate-reactions';

export function isMessageResultV2DTO(
  message: MessageResultDTO | MessageResultV2DTO,
): message is MessageResultV2DTO {
  return !('sentByUserId' in message);
}

export function convertToMessageResultV2(
  message: MessageResultDTO | MessageResultV2DTO,
): MessageResultV2DTO {
  if (isMessageResultV2DTO(message)) {
    return message;
  }

  const userStore = useChatUserStore();
  const userId = userStore.getUserId;
  if (!userId) {
    throw new Error('User ID is not available');
  }

  const reactions = aggregateReactions(message.reactions ?? []);

  message.readMessages = message.readMessages ?? [];
  const isRead = message.readMessages.some(
    readMessage => readMessage.userId === userId,
  );

  const readMessagesCount = isRead
    ? message.readMessages?.length - 1
    : message.readMessages?.length;

  const convertedMessage: MessageResultV2DTO = {
    ...message,
    readMessagesCount,
    reactions,
    ownReaction: message.reactions?.find(reaction => reaction.sentByUserId === userId)?.reaction,
    isRead,
  };

  return convertedMessage;
}
